











import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CalendarAction extends Vue {
    @Prop({ default: null }) color!: string

    click() {
        this.$emit('click');
    }
}
